import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { ConfirmModal, Icon } from '@cps'
import './index.scss'

// interface
interface IProps extends TConfirmModalProps {
}
interface IState{
  formatSaleTimes: string[];
}
const MenuStatusConfirmModal: FC<IProps> = ({ title, confirmText }) => {
  return (
    <ConfirmModal
      className='menu-status-confirm-modal'
      title={title}
      confirmText={confirmText}
    >
      <div className='modal-content'>
        <Icon name='shalou' />
        <div className='sale-time-list'>
          <p>{i18n.t('store.noOrder')}</p>
          <p>{i18n.t('store.findServicer')}</p>
        </div>
      </div>
    </ConfirmModal>
  )
}

export default observer(MenuStatusConfirmModal)
